import { lazy, Suspense, type ReactNode } from "react";
import { useLocation } from "react-router-dom";

const WorkspaceShell = lazy(() =>
  import("./layout/workspace-shell").then((module) => ({
    default: module.WorkspaceShell,
  })),
);

function isMarketingPath(pathname: string): boolean {
  return (
    pathname === "/" ||
    pathname === "/about" ||
    pathname === "/contact" ||
    pathname === "/insights" ||
    pathname.startsWith("/insights/") ||
    pathname === "/legal" ||
    pathname === "/pricing" ||
    pathname === "/privacy" ||
    pathname === "/terms"
  );
}

function isAuthPath(pathname: string): boolean {
  return (
    pathname === "/forgot-password" ||
    pathname === "/reset-password" ||
    pathname.startsWith("/reset-password/") ||
    pathname === "/sign-in" ||
    pathname.startsWith("/sign-in/") ||
    pathname === "/sign-up" ||
    pathname.startsWith("/sign-up/")
  );
}

function isOnboardingPath(pathname: string): boolean {
  return pathname === "/welcome" || pathname.startsWith("/welcome/");
}

function WorkspaceShellFallback() {
  return (
    <div className="beta-shell workspace-shell">
      <main className="workspace-main">
        <div className="app-route-loading" role="status" aria-live="polite">
          Loading workspace...
        </div>
      </main>
    </div>
  );
}

export function AppShell({ children }: { children: ReactNode }) {
  const location = useLocation();
  const isOnboardingRoute = isOnboardingPath(location.pathname);
  const isMarketingRoute = isMarketingPath(location.pathname);

  if (isMarketingRoute || isAuthPath(location.pathname) || isOnboardingRoute) {
    return <>{children}</>;
  }

  return (
    <Suspense fallback={<WorkspaceShellFallback />}>
      <WorkspaceShell>{children}</WorkspaceShell>
    </Suspense>
  );
}
